import RYBConnectEvents from "../../common/services/events.service";
import { closeModal } from "../../common/views/modal.view";
import { initEventFilters } from "./services/event-filter.service";
import { setEventView } from "./views/event.view";

jQuery(async function ($) {
  try {
    const hasCampsComponent = $("#ryb-connect-camps-list");
    const hasParentsNightOut = $("#ryb-connect-parents-night-out-list");
    const hasClinicComponent = $("#ryb-connect-clinic-list");
    const hasHomeOfFitKidsComponent = $("#ryb-connect-home-of-fit-kids-list");
    const hasPreschool = $("#ryb-connect-scl-preschool-list");
    const hasRYBCategoriesComponent = $("#ryb-connect-categories");
    if (
      !hasCampsComponent.length &&
      !hasParentsNightOut.length &&
      !hasClinicComponent.length &&
      !hasHomeOfFitKidsComponent.length &&
      !hasPreschool.length &&
      !hasRYBCategoriesComponent.length
    ) {
      return;
    }

    const events = new RYBConnectEvents();
    const camps = (await events.getCamps()) || [];
    const pno = (await events.getParentsNightOut()) || [];
    const clinics = (await events.getClinic()) || [];
    const homeOfFitKids = (await events.getHomeOfFitKids()) || [];
    const sclPreschool = (await events.getSCLPreschool()) || [];

    if (hasCampsComponent.length) {
      await setEventView(camps, "#ryb-connect-camps-list");
      const campsContainerId = hasCampsComponent.closest("[id$='-container']").attr("id");
      if (campsContainerId) {
        initEventFilters(campsContainerId, camps, "#ryb-connect-camps-list");
      }
    }
    if (hasParentsNightOut) {
      await setEventView(pno, "#ryb-connect-parents-night-out-list");
    }
    if (hasClinicComponent) {
      await setEventView(clinics, "#ryb-connect-clinic-list");
    }
    if (hasHomeOfFitKidsComponent) {
      await setEventView(homeOfFitKids, "#ryb-connect-home-of-fit-kids-list");
    }
    if (hasPreschool) {
      await setEventView(sclPreschool, "#ryb-connect-scl-preschool-list", true);
    }
    // the new shortcode
    if (hasRYBCategoriesComponent?.length > 0) {
      const allRybConnectCategoriesOnPage: any = document.querySelectorAll(
        "#ryb-connect-categories"
      );
      const isMultiple = allRybConnectCategoriesOnPage?.length > 1;
      if (isMultiple) {
        for (const rybConnectCategoryOnPage of allRybConnectCategoriesOnPage) {
          const keyAttribute =
            rybConnectCategoryOnPage.getAttribute("data_multiple_key");
          const element = $(
            `#ryb-connect-categories[data_multiple_key='${keyAttribute}']`
          );
          const filterKey = element.attr("data-filter-key");
          const filterName = element.attr("data-filter-name")?.split(",");
          if (!filterKey || !filterName) {
            console.error(
              "please provide filterKey and filterValue in the shortcode."
            );
            return;
          }
          const eventsResult = await events.getShortcodeData(
            filterKey,
            filterName
          );
          if (eventsResult) {
            await setEventView(
              eventsResult,
              `#ryb-connect-categories[data_multiple_key='${keyAttribute}'] #ryb-connect-list`
            );
          }
        }
      } else {
        const filterKey = hasRYBCategoriesComponent.attr("data-filter-key");
        const filterName = hasRYBCategoriesComponent
          .attr("data-filter-name")
          ?.split(",");
        if (!filterKey || !filterName) {
          console.error(
            "please provide filterKey and filterValue in the shortcode."
          );
          return;
        }
        const eventsResult = await events.getShortcodeData(
          filterKey,
          filterName
        );
        if (eventsResult) {
          await setEventView(eventsResult, "#ryb-connect-list");
          // Wire the Session/Month/Age filter bar above the list.
          // The filter bar is injected as a sibling of #ryb-connect-list
          // inside #ryb-connect-categories, so it survives re-renders.
          const categoriesId = hasRYBCategoriesComponent.attr("id");
          if (categoriesId) {
            initEventFilters(categoriesId, eventsResult, "#ryb-connect-list");
          }
        }
      }
    }

    if ($("#form.ryb-connect-overlay")) {
      $("#form.ryb-connect-overlay").on("click", (event) => {
        if ($(event.target).hasClass("show")) {
          $("#form .ryb-connect-modal .registration-form").removeClass(
            "show-field"
          );
          $("#form .ryb-connect-modal .modal-content").addClass("show-field");
          closeModal();
        }
      });
    }
    if ($("#form .ryb-connect-modal")) {
      $("#form .ryb-connect-modal .register-button").on("click", (event) => {
        event.preventDefault();
        $("#form .ryb-connect-modal .registration-form").addClass("show-field");
        $("#form .ryb-connect-modal .modal-content").removeClass("show-field");
      });
    }
  } catch (error) {
    console.error("Error initializing category list : ", error);
  }
});
